var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 13,
    viewBox: "0 0 32 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 12.8,
    rx: 5.81818,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9251 4V9.6414H12.2436C12.143 9.6414 12.0578 9.62591 11.9881 9.59494C11.921 9.56138 11.8539 9.50459 11.7867 9.42457L9.12673 6.05987C9.13706 6.16054 9.14351 6.25863 9.14609 6.35413C9.15125 6.44706 9.15384 6.53482 9.15384 6.61742V9.6414H8V4H8.6892C8.74599 4 8.79375 4.00258 8.83247 4.00774C8.87118 4.01291 8.90603 4.02323 8.93701 4.03872C8.96798 4.05163 8.99767 4.07099 9.02606 4.0968C9.05446 4.12261 9.08672 4.15746 9.12286 4.20134L11.8061 7.58928C11.7932 7.48087 11.7842 7.37632 11.779 7.27565C11.7738 7.1724 11.7713 7.0756 11.7713 6.98526V4H12.9251Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3361 5.0067V6.32316H17.1094V7.29114H15.3361V8.6347H17.6515V9.6414H14.0196V4H17.6515V5.0067H15.3361Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1445 4L24.4022 9.6414H23.2174L22.1564 6.14505C22.1358 6.09084 22.1164 6.03147 22.0984 5.96694C22.0803 5.89983 22.0622 5.83013 22.0442 5.75786C22.0261 5.83013 22.008 5.89983 21.9899 5.96694C21.9719 6.03147 21.9525 6.09084 21.9319 6.14505L20.8555 9.6414H19.6707L17.9283 4H19.0279C19.1415 4 19.2357 4.02581 19.3106 4.07744C19.388 4.12906 19.4383 4.19747 19.4616 4.28265L20.236 7.22532C20.2592 7.31824 20.2824 7.42021 20.3057 7.5312C20.3289 7.63961 20.3521 7.75319 20.3754 7.87193C20.4218 7.62929 20.4786 7.41375 20.5457 7.22532L21.4595 4.28265C21.4827 4.21037 21.5318 4.14584 21.6066 4.08905C21.6841 4.02968 21.777 4 21.8854 4H22.2726C22.3862 4 22.4778 4.0271 22.5475 4.08131C22.6172 4.13294 22.6701 4.20005 22.7063 4.28265L23.6123 7.22532C23.6794 7.40601 23.7362 7.61122 23.7827 7.84096C23.8033 7.7248 23.824 7.61638 23.8446 7.51571C23.8678 7.41246 23.8911 7.31566 23.9143 7.22532L24.6887 4.28265C24.7093 4.20779 24.7584 4.14197 24.8358 4.08518C24.9133 4.02839 25.0062 4 25.1146 4H26.1445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadge);
export default __webpack_public_path__ + "static/media/new-badge.d687fe9e7701664b6d2c9b416496b548.svg";
export { ForwardRef as ReactComponent };